import React, { useState } from 'react';
import classNames from 'classnames/bind';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import Button from 'yoda-core-components/lib/components/Button/Button';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import BarCode from './BarCode';
import SlidePanel from '../SlidePanel/SlidePanel';
import CMCouponPanelHeader from '../CMCouponPage/CMCouponPanelHeader';
import { getDeviceType } from '../../selectors/CMPageSelector';
import * as styles from './ShowBarCode.css';

const cx = classNames.bind(styles);

const ShowBarCode = (props) => {
    const item = get(props, 'item', props);
    const [CouponDetailsPanel, setCouponDetailsPanel] = useState(false);
    const deviceType = useSelector((state) => getDeviceType(state));
    const barCodeData = item.offers.reduce((total, value) => {
        if (value.barCode) {
            total.push(value);
        }
        return total;
    }, []);

    const handleClose = () => {
        setCouponDetailsPanel(false);
    };

    const handleOpen = () => {
        setCouponDetailsPanel(true);
    };

    const renderHeader = () => {
        return (
            <CMCouponPanelHeader
                onClosePanel={() => {
                    setCouponDetailsPanel(false);
                }}
            />
        );
    };

    const renderContent = () => {
        return (
            <div
                className={`${cx('detailsWrapper', 'alignCenter')} ${dt([
                    'mx-auto',
                    'mt-6',
                    'text-center',
                    'overflow-auto',
                ])}`}
            >
                <div className={`${cx('barcodeDetailsWrapper')} ${dt(['mx-6'])}`}>
                    <BarCode barcodeData={item} teaserTitle={item.teaserTitle} />
                </div>
            </div>
        );
    };

    const renderStoreBarcodeButton = () => {
        return deviceType.isMobile ? (
            <Button
                type="button"
                automationId="at-show-barcode-btn"
                buttonType="Secondary"
                size="Xl"
                deviceType={deviceType}
                className={dt([
                    '@apply',
                    'flex',
                    'flex-col',
                    'justify-center',
                    'items-center',
                    'py-2',
                    'px-6',
                    'gap-1',
                    'border-gray-900',
                    'rounded-lg',
                    'h-10',
                    'min-w-[279px]',
                    'text-black',
                ])}
                onClick={handleOpen}
            >
                Store Barcode
            </Button>
        ) : (
            <a
                automationId="at-show-barcode-btn"
                buttonType="Secondary"
                size="Xl"
                className={dt([
                    '@apply',
                    'font-normal',
                    'text-sm',
                    'leading-5',
                    'font-open-sans',
                    'text-gray-70',
                    'capitalize',
                    'p-0',
                    'h-5',
                    'underline',
                    'text-black',
                ])}
                onClick={handleOpen}
            >
                Store Barcode
            </a>
        );
    };
    return (
        <div className={cx('coupon', 'couponBarcode')}>
            {barCodeData.length ? (
                <div className={dt([item?.redeemingChannel !== 'instore' ? 'pt-4' : 'md:pt-4'])}>
                    <>
                        {renderStoreBarcodeButton()}
                        <SlidePanel
                            isOpenPanel={CouponDetailsPanel}
                            panelIcon="close"
                            panelHeaderRenderer={() => renderHeader()}
                            onClosePanel={handleClose}
                        >
                            {renderContent()}
                        </SlidePanel>
                    </>
                </div>
            ) : null}
        </div>
    );
};

export default ShowBarCode;
